export const COLORS = [
  '#ec691a',
  '#c7a755',
  '#e03515',
  '#f5b830',
  '#a04010',
  '#f8d870',
  '#7a2008',
  '#f09050',
  '#b58d00',
  '#fce8b0', 
  '#8c8c8c',
];

export const generateChartColors = (count: number): string[] => {
  if (count <= COLORS.length) {
    return COLORS.slice(0, count);
  }
  const extras = Array.from(
    { length: count - COLORS.length },
    (_, i) => `hsl(${Math.round((i * 360) / (count - COLORS.length))}, 60%, 48%)`
  );
  return [...COLORS, ...extras];
};
